/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Ticker_NodeInputs */

const bn_cipher_ticker_node = /** @type {(inputs: Cipher_Ticker_NodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সাইফার কার্টোগ্রাফিক নোড`)
};

const de_cipher_ticker_node = /** @type {(inputs: Cipher_Ticker_NodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CHIFFRE-KARTOGRAPHISCHER KNOTEN`)
};

const el_cipher_ticker_node = /** @type {(inputs: Cipher_Ticker_NodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ΚΡΥΠΤΟΓΡΑΦΙΚΟΣ ΚΟΜΒΟΣ`)
};

const en_cipher_ticker_node = /** @type {(inputs: Cipher_Ticker_NodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CIPHER CARTOGRAPHIC NODE`)
};

const es_cipher_ticker_node = /** @type {(inputs: Cipher_Ticker_NodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NODO CARTOGRAFICO CIFRADO`)
};

const fr_cipher_ticker_node = /** @type {(inputs: Cipher_Ticker_NodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NŒUD CARTOGRAPHIQUE CIPHER`)
};

const hi_cipher_ticker_node = /** @type {(inputs: Cipher_Ticker_NodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सिफर कार्टोग्राफ़िक नोड`)
};

const hu_cipher_ticker_node = /** @type {(inputs: Cipher_Ticker_NodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CIPHER KARTOGRÁFIAI CSOMÓPONT`)
};

const id_cipher_ticker_node = /** @type {(inputs: Cipher_Ticker_NodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NODE KARTOGRAFIS CIPHER`)
};

const it_cipher_ticker_node = /** @type {(inputs: Cipher_Ticker_NodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NODO CARTOGRAFICO CIFRATO`)
};

const ja_cipher_ticker_node = /** @type {(inputs: Cipher_Ticker_NodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暗号地図作成ノード`)
};

const ko_cipher_ticker_node = /** @type {(inputs: Cipher_Ticker_NodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`암호 지도 제작 노드`)
};

const nl_cipher_ticker_node = /** @type {(inputs: Cipher_Ticker_NodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CIPHER CARTOGRAFISCHE KNOOPPUNT`)
};

const pl_cipher_ticker_node = /** @type {(inputs: Cipher_Ticker_NodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WĘZEŁ SZYFROWY KARTOGRAFICZNY`)
};

const pt_cipher_ticker_node = /** @type {(inputs: Cipher_Ticker_NodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NÓ CARTOGRÁFICO CIPHER`)
};

const ru_cipher_ticker_node = /** @type {(inputs: Cipher_Ticker_NodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ШИФРОВОЙ КАРТОГРАФИЧЕСКИЙ УЗЕЛ`)
};

const sv_cipher_ticker_node = /** @type {(inputs: Cipher_Ticker_NodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CIFFER KARTOGRAFISK NOD`)
};

const tr_cipher_ticker_node = /** @type {(inputs: Cipher_Ticker_NodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ŞİFRE KARTOGRAFİK DÜĞÜM`)
};

const uk_cipher_ticker_node = /** @type {(inputs: Cipher_Ticker_NodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ШИФРОВИЙ КАРТОГРАФІЧНИЙ ВУЗОЛ`)
};

const vi_cipher_ticker_node = /** @type {(inputs: Cipher_Ticker_NodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NÚT BẢN ĐỒ MẬT BẢN`)
};

const zh_cipher_ticker_node = /** @type {(inputs: Cipher_Ticker_NodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码制图节点`)
};

const zh_hant_cipher_ticker_node = /** @type {(inputs: Cipher_Ticker_NodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密碼製圖節點`)
};

/**
* | output |
* | --- |
* | "CIPHER CARTOGRAPHIC NODE" |
*
* @param {Cipher_Ticker_NodeInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_ticker_node = /** @type {((inputs?: Cipher_Ticker_NodeInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Ticker_NodeInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_ticker_node(inputs)
	if (locale === "de") return de_cipher_ticker_node(inputs)
	if (locale === "el") return el_cipher_ticker_node(inputs)
	if (locale === "en") return en_cipher_ticker_node(inputs)
	if (locale === "es") return es_cipher_ticker_node(inputs)
	if (locale === "fr") return fr_cipher_ticker_node(inputs)
	if (locale === "hi") return hi_cipher_ticker_node(inputs)
	if (locale === "hu") return hu_cipher_ticker_node(inputs)
	if (locale === "id") return id_cipher_ticker_node(inputs)
	if (locale === "it") return it_cipher_ticker_node(inputs)
	if (locale === "ja") return ja_cipher_ticker_node(inputs)
	if (locale === "ko") return ko_cipher_ticker_node(inputs)
	if (locale === "nl") return nl_cipher_ticker_node(inputs)
	if (locale === "pl") return pl_cipher_ticker_node(inputs)
	if (locale === "pt") return pt_cipher_ticker_node(inputs)
	if (locale === "ru") return ru_cipher_ticker_node(inputs)
	if (locale === "sv") return sv_cipher_ticker_node(inputs)
	if (locale === "tr") return tr_cipher_ticker_node(inputs)
	if (locale === "uk") return uk_cipher_ticker_node(inputs)
	if (locale === "vi") return vi_cipher_ticker_node(inputs)
	if (locale === "zh") return zh_cipher_ticker_node(inputs)
	return zh_hant_cipher_ticker_node(inputs)
});